export function getWindowDragHandleClassname() {
  return 'WindowDragHandle';
}

export function getWindowDragCancelClassname() {
  return 'WindowDragCancel';
}
